export default __webpack_public_path__ + "static/media/unlinkBankIcon.a2cecfac.svg";